// extracted by mini-css-extract-plugin
export var badges = "FooterMain-module--badges--17f2d";
export var bottomPart = "FooterMain-module--bottomPart--936a5";
export var footerLogo = "FooterMain-module--footerLogo--38378";
export var lSide = "FooterMain-module--lSide--6a986";
export var lbSide = "FooterMain-module--lbSide--cff2f";
export var logo = "FooterMain-module--logo--5bf3c";
export var mainPart = "FooterMain-module--mainPart--1f53b";
export var rSide = "FooterMain-module--rSide--707e8";
export var ratingWrap = "FooterMain-module--ratingWrap--b9a15";
export var rbSide = "FooterMain-module--rbSide--53783";
export var root = "FooterMain-module--root--fc59f";
export var security = "FooterMain-module--security--fa6b3";
export var statement = "FooterMain-module--statement--c3dcc";
export var text = "FooterMain-module--text--db57e";